import React, { useRef } from "react";
import s from "./AboutPage.module.css";
import { FaArrowCircleDown } from "react-icons/fa";
import avatar from "../../assets/i5.png";
import gostinaya from "../../assets/gostinaya.png";

export default function AboutPage() {
  const nextSectionRef = useRef(null);

  const scrollToNextSection = () => {
    if (nextSectionRef.current) {
      nextSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div>
      <div className={s.banner}>
        <div className={s.content_wrapper}>
          <div className={s.content}>
            <p>
              Hi! My name is Ivan Morozov. <br />
              I am a visual designer specializing in interiors and small
              architectural forms. <br />
              Many people find it difficult to understand drawings or to imagine
              their future interior as a whole. That’s where I can help.
            </p>

            <FaArrowCircleDown
              className={s.scroll_doun}
              onClick={scrollToNextSection}
            />
          </div>
        </div>
      </div>
      <div
        className={`${s.block_about} ${s.content_wrapper}`}
        ref={nextSectionRef}
      >
        <div className={s.block_about_content}>
          <p>
            Let me tell you more about my background: <br />
            I have extensive experience in design, graphics, rendering and 3D
            modeling for interiors and exteriors, as well as strong
            collaboration with architects and designers. <br />
            I work with software such as 3ds Max (Corona, V-Ray), Blender, Adobe
            Photoshop, and CorelDRAW. <br />
            In 2006, I graduated from the Kyrgyz-Russian Slavic University
            (KRSU) with a Master’s degree in Architecture. <br />
            <br />
            - After graduation, I worked independently as an interior designer,
            focusing on apartments, houses, and restaurants. <br />
            - From 2010 to 2014, I worked at IND Architects, gaining valuable
            experience in visualization, collaboration with partners and
            material manufacturers, and direct client interaction. Later, I had
            the opportunity to continue with the studio in Moscow, where I was
            involved in larger projects, including apartments, houses,
            restaurants, and food courts. <br />
            - From 2016 to 2021, I worked as a designer for Balter GmbH and
            Avaloid GmbH in Düsseldorf. My tasks included product visualizations
            for websites and advertising, packaging design, promotional
            materials, 3D mock-ups for exhibition halls, and office space
            design. <br />- In recent years, I have also been working as a
            freelance visual designer, collaborating closely with architects and
            other designers. <br />
            <br />
            This work inspires me and is very close to my heart. It is always
            rewarding to see a visualization come to life. I believe strongly in
            my skills and motivation to create meaningful and engaging projects.
          </p>
          <img src={avatar} alt="avatar" />
        </div>
      </div>
      <div className={s.download_wrapper}>
        <button className={s.download_button}>
          <a
            href="https://drive.google.com/file/d/1jSvHsOlQKvW1fB306OsptpZD-e2OiRGS/view?usp=sharing"
            download
          >
            CV/Resume
          </a>
        </button>

        <button className={s.download_button}>
          <a
            href="https://drive.google.com/file/d/18DR1zuvWpr4BmM_1Hl9s0bT66fMvSAMS/view?usp=sharing"
            download
          >
            View Certificate
          </a>
        </button>
        <button className={s.download_button}>
          <a href="https://3dsky.org/users/morosow/models">View 3ddd models</a>
        </button>
      </div>
      <div className={`${s.banner} ${s.banner_down}`}>
        <div className={`${s.content_wrapper} ${s.content_wrapper_down}`}>
          <p className={s.content}>Work and Enjoy Life!</p>
          <img src={gostinaya} alt="gostinaya" />
        </div>
      </div>
    </div>
  );
}
